import { OVERLAY_PROMOTION_SHOW } from '@spinwise/spinwise-core';
import axios from 'axios';
import { getCookie } from 'cookies-next';
import router from 'next/router';

export const openPromoModal = async (slug, dispatch) => {
  const currentLocale = router.locale;
  const geo = getCookie('country');
  try {
    const res = await axios.get(
      `/api/content/promotions?locale=${currentLocale}&populate=deep&filters[brand][slug]=winnerz&filters[slug]=${slug}&geo=${geo}`,
    );

    const promo = res.data?.[0] ?? null;

    dispatch({
      type: OVERLAY_PROMOTION_SHOW,
      content: {
        show: true,
        content: promo,
      },
    });
  } catch (error) {
    return { error };
  }
};
